import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { map, slice } from 'lodash';
import { Context as AppContext } from '../contexts/AppContext';

const Base = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  padding: 1rem;
`;

const ToastBase = styled.div.attrs({
  className: 'toast',
})`
  opacity: 1;
  min-width: 22.5rem;
  .close {
    outline: 0;
  }
  .toast-title {
    flex: 1;
  }
`;

export function Toast({ toast, onClose }) {
  useEffect(() => {
    let timer;
    if (toast.timeout !== 0) {
      timer = setTimeout(onClose, toast.timeout || 5000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [toast, onClose]);
  return (
    <ToastBase>
      <div className="toast-header">
        <strong className="toast-title">{toast.title || 'Notice'}</strong>
        <button
          type="button"
          className="close ml-2 mb-1"
          onClick={onClose}
        >
          <span>&times;</span>
        </button>
      </div>
      <div className="toast-body">
        {toast.body}
      </div>
    </ToastBase>
  );
}

Toast.propTypes = {
  toast: PropTypes.shape({ title: PropTypes.string, body: PropTypes.node }).isRequired,
  onClose: PropTypes.func,
};

Toast.defaultProps = {
  onClose: () => null,
};

export function Toasts() {
  const { toasts, setToasts } = useContext(AppContext);
  return (
    <Base>
      {
        map(toasts, (toast, idx) => (
          <Toast
            key={idx}
            toast={toast}
            onClose={() => {
              setToasts([
                ...slice(toasts, 0, idx),
                ...slice(toasts, idx + 1),
              ]);
            }}
          />
        ))
      }
    </Base>
  );
}
